import React from 'react'
import { useReactiveVar } from '@apollo/client'
import { calculatorVar } from '../../../apollo/reactive-vars'
import {
  BoreholeFieldContainerInput,
  BuildingFragment,
} from '../../../generated/graphql'
import { Printable } from '../../common/Printable'
import { SystemContainerBoreholeField } from '../../system-container/borehole-field/SystemContainerBoreholeField'
import { useBuildings } from '../../../building/use-buildings'

type Props = {
  building: BuildingFragment
}

export function BuildingBoreholeFieldTab({
  building,
}: Props): React.ReactElement {
  const calculator = useReactiveVar(calculatorVar)
  const { updateBuildingBoreholeField } = useBuildings()

  const buildingCalculator = calculator?.findBuilding(building.id)

  if (!buildingCalculator) {
    return <></>
  }

  const providers = buildingCalculator.getProviders()

  const updateContainer = async (input: BoreholeFieldContainerInput) => {
    await updateBuildingBoreholeField(building.id, input)
  }

  return (
    <Printable>
      <SystemContainerBoreholeField
        container={building}
        updateContainer={updateContainer}
        providers={providers}
      />
    </Printable>
  )
}
